import React from 'react'
import { useDispatch } from 'react-redux';
import { openPopup } from "../../../store/popupSlice"
import { Link } from 'react-router-dom'

export default function OnDemandFuture() {
    const dispatch = useDispatch();
  return (
    <>
      <section className="ondemand-future">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6">
              <div className="blink-feature-image br-img-animation">
                <img loading="lazy" src={"/assets/home/ondemand-future.webp"} alt="technology" className="img-responsive" />
                <div className="br-animate-box"></div>
              </div>
            </div>

            <div className="col-lg-7 col-md-6">
              <div className="ondemand-future-content">
                <label>Mobility Infotech</label>
                <h2 className="heading">Building Future-Ready On-Demand Delivery Apps</h2>
                <p>Looking to launch, expand, or modernize your on-demand delivery business? Mobility Infotech designs and develops future-ready, white-label on-demand delivery applications tailored to your business model and brand identity.</p>
                <p>Our delivery platforms are built for speed, scalability, and reliability. They help you go live faster, streamline operations, enhance customer engagement, and maintain a competitive edge in fast-moving markets.</p>
                <ul>
                  <li>Proven Global Experience</li>
                  <li>End-to-End Brand Customisation</li>
                  <li>Rapid Deployment and Enterprise-Level Scalability</li>
                </ul>
                <Link onClick={() => dispatch(openPopup())} className="default-btn">Start your project</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
